/**
 * Statuses used by the native (MongoDB-backed) DCR store. Studies still served by the
 * Salesforce store use a different set and are not shown through this experience.
 */
export var EDcrStatus;
(function (EDcrStatus) {
    EDcrStatus["OPEN"] = "Open";
    EDcrStatus["IN_PROGRESS"] = "In progress";
    EDcrStatus["RESOLVED"] = "Resolved";
    EDcrStatus["DECLINED"] = "Declined";
    EDcrStatus["CANCELLED"] = "Cancelled";
})(EDcrStatus || (EDcrStatus = {}));
/**
 * Values sent to and stored by the connector. The UI labels differ (see DCR_TYPE_LABELS):
 * these strings are what the connector's automation and reporting already key off.
 */
export var EDcrType;
(function (EDcrType) {
    EDcrType["UPDATE_PARTICIPANT_NUMBER"] = "update participant id";
    EDcrType["INACTIVATE_RESPONSE"] = "inactivate task response";
    EDcrType["UPDATE_SITE_RESPONSE"] = "update site response";
    EDcrType["UPDATE_PARTICIPANT_RESPONSE"] = "update participant response";
    EDcrType["UPDATE_VISIT_DATE"] = "update visit date";
    EDcrType["INACTIVATE_PARTICIPANT"] = "inactivate participant";
    EDcrType["MOVE_PARTICIPANT_TO_ANOTHER_SITE"] = "move participant to a different site";
    EDcrType["MOVE_RESPONSES_TO_ANOTHER_VISIT"] = "move completed tasks to another visit";
    EDcrType["OTHER"] = "other";
})(EDcrType || (EDcrType = {}));
export var EDcrReason;
(function (EDcrReason) {
    EDcrReason["INCORRECT_ENTRY"] = "Incorrect entry";
    EDcrReason["OTHER"] = "Other";
})(EDcrReason || (EDcrReason = {}));
export var EDcrCancellationReason;
(function (EDcrCancellationReason) {
    EDcrCancellationReason["ENTERED_IN_ERROR"] = "DCR entered in error";
    EDcrCancellationReason["NO_LONGER_REQUIRED"] = "DCR no longer required";
    EDcrCancellationReason["OTHER"] = "Other";
})(EDcrCancellationReason || (EDcrCancellationReason = {}));
